"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as popout from "./popout";
import {
  attachOcrLineDropListeners,
  forceString,
  formatDate
} from "./ocr_line_drop";
function handleClick(state) {
  popout.setFieldSelection(state.identifier);
}
export default React.createClass({
  getInitialState: function() {
    return {
      identifier: ""
    };
  },
  componentDidMount: function() {
    const input = ReactDOM.findDOMNode(this.refs.input);
    $(input).droppable({
      drop: (event, ui) => {
        return this.applyDroppedValue(event, ui.helper.data("chars"));
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      input,
      (payload, event) => this.applyDroppedValue(event, payload.chars)
    );
    this.state.identifier = popout.setupDocPageLineFromPopoutListener(
      this.handlePopoutListenerUpdate
    );
  },
  componentWillUnmount: function() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  },
  applyDroppedValue(event, value) {
    switch (this.refs.input.getAttribute("type")) {
      case "date":
        return this.props.onDrop(event, formatDate(value));
      default:
        return this.props.onDrop(event, forceString(value));
    }
  },
  handlePopoutListenerUpdate(value) {
    switch (this.refs.input.getAttribute("type")) {
      case "date":
        return this.props.valueLink.requestChange(formatDate(value));
      default:
        return this.props.valueLink.requestChange(forceString(value));
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "input",
      __spreadProps(__spreadValues({
        ref: "input"
      }, this.props), {
        onClick: () => handleClick(this.state)
      })
    );
  }
});
